<template>
  <div :class="$style.container" @click="$emit('click')">
    <div :class="$style.flag">
      <country-flag :language-code="languageCode" />
    </div>
    <div
      :class="[
        $style.arrow,
        { [$style.invertedColor]: invertedColor },
      ]"
    >
      <chevron-up-icon v-if="isShownLanguages" />
      <chevron-down-icon v-else />
    </div>
  </div>
</template>

<script>
import ChevronDownIcon from 'atoms/icons/arrows/ChevronDown';
import ChevronUpIcon from 'atoms/icons/arrows/ChevronUp';
import CountryFlag from 'molecules/localization/CountryFlag';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'LanguageTapBar',
  components: {
    ChevronDownIcon,
    ChevronUpIcon,
    CountryFlag,
  },
  props: {
    languageCode: {
      type: String,
      required: true,
    },
    invertedColor: {
      type: Boolean,
      default: () => false,
    },
  },
  created() {
    EVENT_BUS.$on('show.languages', value => {
      this.isShownLanguages = value;
    });
  },
  data() {
    return {
      isShownLanguages: false,
    };
  },
};
</script>

<style lang="sass" module>
  .container
    display: flex
    align-items: center
    justify-content: space-between

  .flag
    margin-right: 5px

  .arrow
    display: flex

    &.invertedColor
      svg path
        fill: #fff
</style>
